import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { validar } from "../services/medico.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useValidar = ({ id }) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const validarMutation = useMutation({
        mutationFn: ({ id, value }) => validar({ id, value }),
        onSuccess: (_, __, ___) => {
            queryClient.invalidateQueries({ queryKey: ['medico', id] });
            dispatch(successNotification('Médico actualizado'));
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        validarMutation,
    }
}